import { getAxiosInstance } from './axiosInstance';

const useAxios = () => {
  const axiosInstance = getAxiosInstance();
  return axiosInstance;
};


export default useAxios;